import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_PAYROLL_REPORT} from '../../RoutePathConstant';

const PayrollReport = lazy(() =>
  import('../../../screens/PayrollReport')
    .then(module => ({default: module.PayrollReport})));

const PayrollReportNavigation = [
  {
    path:  ROUTE_PAYROLL_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <PayrollReport />
      </Suspense>
    ),
  },
];

export default PayrollReportNavigation;
